// Zod DTOs for the `/v1/cohorts` surface (P3-05, spec §6.2 authoring
// surface) — single source of truth for `apps/api`'s validators + the
// OpenAPI generator, mirroring `./roster.ts`'s header convention for this
// package. (This file used to also hold the `/v1/access-grants` DTOs —
// removed, no consumer — see
// `apps/web/src/views/teacher/TeacherStudentDetailView.vue`'s file header
// for the removal history.)
import { z } from 'zod';
import { idSchema, nameSchema, paginationQuerySchema } from './primitives';

// ─── POST /v1/cohorts ────────────────────────────────────────────────────────

export const cohortCreateRequestSchema = z.object({
  name: nameSchema,
  levelId: idSchema.optional(),
});
export type CohortCreateRequest = z.infer<typeof cohortCreateRequestSchema>;

// ─── GET /v1/cohorts ─────────────────────────────────────────────────────────

export const cohortListQuerySchema = paginationQuerySchema;
export type CohortListQuery = z.infer<typeof cohortListQuerySchema>;

// ─── POST /v1/cohorts/:id/members ────────────────────────────────────────────

export const cohortMemberAddRequestSchema = z.object({
  studentId: idSchema,
});
export type CohortMemberAddRequest = z.infer<typeof cohortMemberAddRequestSchema>;
